const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g fill="currentColor" clip-path="url(#a)"><path d="M12 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0M6 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0M0 8a2 2 0 1 0 4 0 2 2 0 0 0-4 0"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
